import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  IoArrowBackSharp,
  IoSearch,
  IoClose,
  IoPerson,
  IoCalendar,
  IoTime,
  IoPeople,
  IoCheckmarkCircle,
  IoWarning,
} from "react-icons/io5";
import gsap from "gsap";
import logo from "../../Images/logo-4.png";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./SportsBookingModern.css";
import { BASEAPIURL, token } from "../../env";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { formatDate, formatDateNum } from "../commonFunctionlity";

const encrypt = (text, key) => {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const encrypted = CryptoJS.AES.encrypt(text, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
};

export default function SportsBooking({ showBackButton = false }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [facilities, setFacilities] = useState([]);
  const [activeTab, setActiveTab] = useState("Members");
  const [courts, setCourts] = useState([]);
  const [selectedCourt, setSelectedCourt] = useState(null);
  const [slots, setSlots] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [bookingDates, setBookingDates] = useState([]);
  const [playerLimit, setPlayerLimit] = useState(0);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [guests, setGuests] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [dependents, setDependents] = useState([]);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [loadingCourts, setLoadingCourts] = useState(false);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [loadingDependents, setLoadingDependents] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [error, setError] = useState(null);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [modalContent, setModalContent] = useState(null);
  const navigate = useNavigate();
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [facilityGroups, setFacilityGroups] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showNotifications, setShowNotifications] = useState([]);
  const progressBarRef = useRef(null);
  const progressStepsRef = useRef([]);
  const progressLineRef = useRef(null);
  const [healthAvailabilty, setHealthAvailabilty] = useState([]);

  // New state for StaticDatePicker
  const [selectedDate, setSelectedDate] = useState();

  const addNotification = (type, message) => {
    const id = Date.now();
    setShowNotifications((prev) => [...prev, { id, type, message }]);
    setTimeout(() => {
      setShowNotifications((prev) => prev.filter((n) => n.id !== id));
    }, 5000);
  };

  const isValidMobile = (mobile) => {
    return mobile && mobile.length === 10 && /^[6-9]\d{9}$/.test(mobile);
  };

  const areAllMobilesValid =
    guests.length > 0 && guests.every((guest) => isValidMobile(guest.mobile));

  const isValidName = (name) => {
    return name && name.trim().length >= 3;
  };
  const areAllNamesValid =
    guests.length > 0 && guests.every((guest) => isValidName(guest.name));

  const calculateCartTotals = () => {
    let subtotal = 0;
    let discountPercent = 0;
    let taxPercentage = 0;
    let taxIsInclude = false;

    selectedSlots.forEach((slot) => {
      const memberPrice = parseFloat(slot.MemberPrice) || 500;
      const guestPrice = parseFloat(slot.GuestPrice) || 100;

      let basePrice = 0;

      if (slot.IsEachPerson) {
        basePrice = memberPrice + guestPrice;
      } else {
        basePrice =
          selectedMembers.length * memberPrice + guestPrice * guests?.length;
      }

      subtotal += basePrice;

      discountPercent = parseFloat(slot.Discountper) || 0;
      taxPercentage = parseFloat(slot.TaxPercentage) || 0;
      taxIsInclude = slot.TaxIsInclude || false;
    });

    let baseAmount = subtotal;
    let discountedValue = 0;
    let amountAfterDiscount = 0;
    let tax = 0;
    let total = 0;

    if (taxIsInclude) {
      baseAmount = subtotal / (1 + taxPercentage / 100);
      subtotal = baseAmount;
      discountedValue = (baseAmount * discountPercent) / 100;
      amountAfterDiscount = baseAmount - discountedValue;
      tax = (amountAfterDiscount * taxPercentage) / 100;
      total = amountAfterDiscount + tax;
    } else {
      discountedValue = (subtotal * discountPercent) / 100;
      amountAfterDiscount = subtotal - discountedValue;
      tax = (amountAfterDiscount * taxPercentage) / 100;
      total = amountAfterDiscount + tax;
    }

    return {
      subtotal: +subtotal.toFixed(2),
      discountPercent,
      discountedValue: +discountedValue.toFixed(2),
      amountAfterDiscount: +amountAfterDiscount.toFixed(2),
      taxPercentage,
      tax: +tax.toFixed(2),
      total: +total.toFixed(2),
    };
  };

  const getCartItemDetails = (slot) => {
    const memberPrice = parseFloat(slot.MemberPrice) || 500;
    const guestPrice = parseFloat(slot.GuestPrice) || memberPrice + 100;
    let basePrice = 0;
    if (slot.IsEachPerson) {
      const totalMemberCost = selectedMembers.length * memberPrice;
      const totalGuestCost = guests.filter((g) => g.name).length * guestPrice;
      basePrice = totalMemberCost + totalGuestCost;
    } else {
      basePrice = parseFloat(slot.CourtPrice || slot.MemberPrice || 500);
    }
    return {
      slot,
      basePrice,
      memberCount: selectedMembers.length,
      guestCount: guests.filter((g) => g.name).length,
      memberPrice,
      guestPrice,
    };
  };

  const fetchFacilityGroups = async () => {
    setLoadingGroups(true);
    try {
      const url = `${BASEAPIURL}/GetFGrpListS?token=${token}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      let list = Array.isArray(data)
        ? data
        : Array.isArray(data.data)
          ? data.data
          : Array.isArray(data.result)
            ? data.result
            : [];
      setFacilityGroups(list);
      const healthClubGroup = list.find((group) => group.FacilityGroupID === 1);

      if (healthClubGroup && currentStep === 1) {
        handleGroupClick(healthClubGroup);
      }
    } catch (err) {
      setError(`Something went wrong`);
      addNotification("error", "Failed to load facility groups");
    } finally {
      setLoadingGroups(false);
    }
  };
  useEffect(() => {
    fetchFacilityGroups();
  }, []);

  useEffect(() => {
    const storedMemberID = sessionStorage.getItem("MemberID");
    const storedMemberName = sessionStorage.getItem("MemberName");
    if (currentStep >= 4) {
      // Ensure logged-in member is always included from Step 4 onward
      setSelectedMembers((prevMembers) => {
        const alreadyExists = prevMembers.some(
          (m) => String(m.MemID) === String(storedMemberID),
        );
        if (alreadyExists) return prevMembers;

        if (!storedMemberID || !storedMemberName) {
          addNotification("error", "User not logged in");
          return prevMembers;
        }
        return [
          ...prevMembers,
          {
            MemID: storedMemberID,
            MemName: storedMemberName,
            MemMSNO: "Self",
            MemMobileNo: sessionStorage.getItem("MemMobileNo") || "N/A",
          },
        ];
      });

      // Fetch dependents only when entering Step 5 (optional optimization)
      if (currentStep === 5 && storedMemberID && storedMemberName) {
        // ... fetch dependents logic here (keep existing code)
      }
    } else if (currentStep < 4) {
      // setSelectedMembers([]);
    }
  }, [currentStep, selectedMembers]);

  useEffect(() => {
    if (currentStep === 4) {
      const storedMemberID = sessionStorage.getItem("MemberID");
      const storedMemberName = sessionStorage.getItem("MemberName");

      if (storedMemberID && storedMemberName) {
        setSelectedMembers((prevMembers) => {
          const alreadyExists = prevMembers.some(
            (m) => String(m.MemID) === String(storedMemberID),
          );
          if (alreadyExists) return prevMembers;
          return [
            ...prevMembers,
            {
              MemID: storedMemberID,
              MemName: storedMemberName,
              MemMSNO: "Self",
              MemMobileNo: sessionStorage.getItem("MemMobileNo") || "N/A",
            },
          ];
        });
      }

      const fetchDependents = async () => {
        if (!storedMemberID || !storedMemberName) {
          addNotification("error", "User not logged in");
          return;
        }

        setLoadingDependents(true);
        try {
          const raw = JSON.stringify({ tokenData: token });
          const response = await fetch(
            `${BASEAPIURL}/DependentListByMemID?MemID=${storedMemberID}`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: raw,
            },
          );
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const result = await response.json();
          const dependentList = Array.isArray(result)
            ? result
            : Array.isArray(result.data)
              ? result.data
              : Array.isArray(result.result)
                ? result.result
                : [];
          setDependents(dependentList);
        } catch (err) {
          console.log("error", "No dependents available");
        } finally {
          setLoadingDependents(false);
        }
      };

      fetchDependents();
    } else if (currentStep < 5) {
      setSelectedMembers([]);
    }
  }, [currentStep]);

  const handleGroupClick = async (group) => {
    setSelectedFacility(null);
    setFacilities([]);
    setCourts([]);
    setSlots([]);
    setError(null);
    setLoadingCourts(true);
    try {
      const url = `${BASEAPIURL}/GetFacilityBookingByFGrpID?FGrpID=${group.FacilityGroupID}&Token=${token}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      let list = Array.isArray(data)
        ? data
        : Array.isArray(data.data)
          ? data.data
          : Array.isArray(data.result)
            ? data.result
            : [];
      setFacilities(list.filter((f) => f.IsActive !== false));
      setCurrentStep(1.5);
    } catch (err) {
      setError(`Unable to load facilities: ${err.message}`);
      addNotification("error", "Failed to load facilities");
    } finally {
      setLoadingCourts(false);
    }
  };

  const handleFacilityClick = async (facility) => {
    setSelectedFacility(facility);
    setSelectedCourt(null);
    setCourts([]);
    setSlots([]);
    setCurrentStep(2);
    setError(null);
    setLoadingCourts(true);
    try {
      const url = `${BASEAPIURL}/CourtByFacilityID?FacilityID=${facility.Facility_ID}&Token=${token}`;
      const response = await fetch(url);
      if (!response.ok)
        throw new Error(`Failed to fetch courts: ${response.status}`);
      const data = await response.json();
      let courtList = Array.isArray(data)
        ? data
        : Array.isArray(data.data)
          ? data.data
          : Array.isArray(data.result)
            ? data.result
            : [];
      setCourts(courtList);
    } catch (err) {
      setError(err.message);
      addNotification("error", "Failed to load courts");
    } finally {
      setLoadingCourts(false);
    }
  };

  const handleCourtClick = (court) => {
    setSelectedCourt(court);
    setSlots([]);
    setBookingDates([]);
    setSelectedSlots([]);
    setCurrentStep(3);
  };

  const loadSlotsForDate = async (date) => {
    if (!selectedCourt || !selectedFacility) return;

    setLoadingSlots(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASEAPIURL}/GetFacilitySlotbyCourtID?Token=${token}&CourtID=${selectedCourt.CourtID}&Date=${date}&FacilityID=${selectedFacility?.Facility_ID}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );
      if (!response.ok)
        throw new Error(`Failed to load slots for ${date}: ${response.status}`);
      const data = await response.json();
      let slotList = Array.isArray(data)
        ? data
        : data.data && Array.isArray(data.data)
          ? data.data
          : data.result && Array.isArray(data.result)
            ? data.result
            : [];

      // Add date to each slot
      const slotsWithDate = slotList.map((slot) => ({
        ...slot,
        BookingDate: date,
      }));

      // Update slots state
      setSlots((prev) => {
        // Remove existing slots for this date
        const filtered = prev.filter((s) => s.BookingDate !== date);
        // Add new slots for this date
        return [...filtered, ...slotsWithDate];
      });
    } catch (err) {
      setError(`Error loading slots: ${err.message}`);
      addNotification("error", "No booking Slots Found");
    } finally {
      setLoadingSlots(false);
    }
  };
  // Load slots when a date is selected
  const GetHealthAvailability = async (date) => {
    if (!selectedCourt || !selectedFacility) return;

    setLoadingSlots(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASEAPIURL}/GetHealthAvailability?CourtID=${selectedCourt.CourtID}&EDate=${date}&FtyID=${selectedFacility?.Facility_ID}&Token=${token}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );
      if (!response.ok)
        throw new Error(`Failed to load slots for ${date}: ${response.status}`);
      const data = await response.json();
      setHealthAvailabilty(data?.data);
    } catch (err) {
      setError(`Error loading slots: ${err.message}`);
    } finally {
      setLoadingSlots(false);
    }
  };

  const handleDateChange = (newDate) => {
    if (newDate) {
      setSelectedDate(newDate);
      const dateStr = newDate.format("YYYY-MM-DD");
      if (!bookingDates.includes(dateStr)) {
        const newDates = [...bookingDates, dateStr].sort();
        setBookingDates(newDates);
        // Load slots for the newly selected date
        loadSlotsForDate(dateStr);
        GetHealthAvailability(dateStr);
      }
    }
  };

  const removeDate = (dateToRemove) => {
    setBookingDates(bookingDates.filter((date) => date !== dateToRemove));
    // Remove slots for this date
    setSlots(slots.filter((slot) => slot.BookingDate !== dateToRemove));
    // Also remove any selected slots for this date
    setSelectedSlots(
      selectedSlots.filter((slot) => slot.BookingDate !== dateToRemove),
    );
  };

  const handleSlotClick = (slot) => {
    const isSelected = selectedSlots.find(
      (s) => s.SlotID === slot.SlotID && s.BookingDate === slot.BookingDate,
    );
    if (isSelected) {
      setSelectedSlots(
        selectedSlots.filter(
          (s) =>
            !(s.SlotID === slot.SlotID && s.BookingDate === slot.BookingDate),
        ),
      );
    } else {
      setSelectedSlots([...selectedSlots, slot]);
      setPlayerLimit(parseInt(slot.PlayerAllowed) || 4);
    }
  };

  useEffect(() => {
    if (searchQuery.length < 2) {
      setSearchResults([]);
      return;
    }
    setLoadingMembers(true);
    const timer = setTimeout(async () => {
      try {
        const raw = JSON.stringify({ tokenData: token });
        const response = await fetch(
          `${BASEAPIURL}/MemberSearchedList?Search=${encodeURIComponent(
            searchQuery,
          )}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: raw,
          },
        );
        if (!response.ok) throw new Error("Search failed");
        const res = await response.json();
        if (res.status && Array.isArray(res.data)) {
          setSearchResults(res.data);
        } else {
          setSearchResults([]);
        }
      } catch (err) {
        console.error("Member search error:", err);
        setSearchResults([]);
      } finally {
        setLoadingMembers(false);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const addGuest = () => {
    // Validate the last guest input before adding a new one
    const invalidGuest = guests.find(
      (g) => !g.name?.trim() || !g.mobile?.trim(),
    );
    if (invalidGuest) {
      alert("Each guest must have a Name and Mobile No.");
      return;
    }

    const totalPlayers = selectedMembers.length + guests.length;
    if (totalPlayers < playerLimit) {
      setGuests([...guests, { name: "", mobile: "" }]);
    } else {
      addNotification("warning", `Maximum ${playerLimit} players allowed`);
    }
  };

  const removeGuest = (index) => {
    const updated = [...guests];
    updated.splice(index, 1);
    setGuests(updated);
  };

  // Updated steps array - removed step 4, shifted others
  const steps = [
    {
      label: "Sports Type",
      detail: selectedFacility
        ? selectedFacility.Facility_Name
        : "Please Select",
      icon: <IoPeople className="icon" />,
    },
    {
      label: "Court",
      detail: selectedCourt ? selectedCourt.CourtName : "Please Select",
      icon: <IoCalendar className="icon" />,
    },
    {
      label: "Dates & Slots",
      detail:
        selectedSlots.length > 0
          ? `${selectedSlots.length} slot(s)`
          : "Please Select",
      icon: <IoCalendar className="icon" />,
    },
    {
      label: "Players",
      detail:
        selectedMembers.length + guests.length > 0
          ? `${selectedMembers.length + guests.length} player(s)`
          : "Please Select",
      icon: <IoPeople className="icon" />,
    },
    {
      label: "Review",
      detail: "Confirm & Pay",
      icon: <IoCheckmarkCircle className="icon" />,
    },
  ];

  const goBack = () => {
    if (currentStep === 5) {
      // Was 6, now 5
      setCurrentStep(4);
      return;
    }
    setCurrentStep((prev) => Math.max(prev - 1, 1));
    if (currentStep === 4) {
      // Was 5, now 4
      setSelectedSlots([]);
    } else if (currentStep === 3) {
      // Combined step
      setSlots([]);
      setSelectedCourt(null);
    } else if (currentStep === 2) {
      setSelectedFacility(null);
    }
  };

  useEffect(() => {
    if (currentStep === 5) {
      // Was 6, now 5
      const items = selectedSlots.map((slot) => getCartItemDetails(slot));
      setCartItems(items);
    }
  }, [currentStep, selectedSlots]);

  useEffect(() => {
    if (
      progressBarRef.current &&
      progressStepsRef.current.length > 0 &&
      progressLineRef.current
    ) {
      gsap.set(progressLineRef.current, {
        width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
      });
      progressStepsRef.current.forEach((step, index) => {
        if (step) {
          if (index < currentStep - 1) {
            gsap.set(step, {
              borderRadius: "27px",
              backgroundColor: "#28a745",
              borderColor: "#28a745",
            });
          } else if (index === currentStep - 1) {
            gsap.set(step, {
              borderRadius: "27px",
              backgroundColor: "#007bff",
              borderColor: "#007bff",
            });
          } else {
            gsap.set(step, {
              backgroundColor: "#e9ecef",
              borderColor: "#dee2e6",
            });
          }
        }
      });
    }
  }, [currentStep, steps.length]);

  useEffect(() => {
    if (
      progressBarRef.current &&
      progressStepsRef.current.length > 0 &&
      progressLineRef.current
    ) {
      gsap.to(progressLineRef.current, {
        width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
        duration: 0.5,
        ease: "power2.out",
      });
      progressStepsRef.current.forEach((step, index) => {
        if (step) {
          gsap.to(step, {
            backgroundColor:
              index < currentStep - 1
                ? "#28a745"
                : index === currentStep - 1
                  ? "#007bff"
                  : "#e9ecef",
            borderColor:
              index < currentStep - 1
                ? "#28a745"
                : index === currentStep - 1
                  ? "#007bff"
                  : "#dee2e6",
            duration: 0.5,
            ease: "power2.out",
          });
        }
      });
    }
  }, [currentStep, steps.length]);

  const handleSubmitBooking = async () => {
    const storedMemberID = sessionStorage.getItem("MemberID");
    const storedMemberName = sessionStorage.getItem("MemberName");

    if (!storedMemberID || !storedMemberName) {
      addNotification("error", "User not logged in.");
      return;
    }

    if (selectedSlots.length === 0) {
      addNotification("warning", "Please select at least one slot.");
      return;
    }

    const bookingDtl = selectedSlots.map((slot) => {
      const memberPrice = parseFloat(slot.MemberPrice) || 500;
      const guestPrice = parseFloat(slot.GuestPrice) || memberPrice + 100;
      const { tax, discountPercent, discountedValue, amountAfterDiscount } =
        calculateCartTotals();

      const BookingMemDtl = [
        ...selectedMembers.map((m) => ({
          MemberType: "self",
          Name: m.MemName,
          MobileNo: m.MemMobileNo || "N/A",
        })),
        ...guests
          .filter((g) => g.name)
          .map((g) => ({
            MemberType: "Guest",
            Name: g.name,
            MobileNo: g.mobile || "N/A",
          })),
      ];

      return {
        Fty_ID: selectedFacility?.Facility_ID,
        FtyCourt_ID: selectedCourt?.CourtID,
        SlotID: slot.SlotID,
        EventDate: new Date(slot.BookingDate).toISOString(),
        BookingRate: +amountAfterDiscount.toFixed(2),
        GSTAmount: +tax.toFixed(2),
        Is_TaxInclude: slot.TaxIsInclude || false,
        DiscountAmount: +discountedValue.toFixed(2),
        DiscountPercentage: discountPercent,
        BookingMemDtl,
      };
    });

    const totalBookingPrice = bookingDtl.reduce(
      (sum, item) => sum + item.BookingRate,
      0,
    );

    const totalTaxAmount = bookingDtl.reduce(
      (sum, item) => sum + item.GSTAmount,
      0,
    );
    const bookingDisAmount = bookingDtl.reduce(
      (sum, item) => sum + item.DiscountAmount,
      0,
    );

    const amountAfterDiscount = totalBookingPrice - bookingDisAmount;
    const grossTotal = totalBookingPrice + totalTaxAmount;
    const totalNetAmount = grossTotal - bookingDisAmount;

    const booking = {
      BookingDate: new Date().toISOString(),
      MemberID: parseInt(storedMemberID),
      BookingSaveDate: new Date().toISOString(),
      BookingPrice: +totalBookingPrice.toFixed(2),
      BookingTaxAmount: +totalTaxAmount.toFixed(2),
      BookingNetAmount: +totalNetAmount.toFixed(2),
      BookingPaymentStatus: "pending",
      BookingPadAmount: +totalNetAmount.toFixed(2),
      BookingDisAmount: +bookingDisAmount.toFixed(2),
      amountAfterDiscount: +amountAfterDiscount.toFixed(2),
      BookingDtl: bookingDtl,
    };

    const cartItem = {
      type: "Health",
      apiType: "health",
      guestNum: guests.filter((g) => g.name).length,
      booking,
    };

    localStorage.setItem("cart", JSON.stringify(cartItem));
    navigate("/dashboard/cart");

    // try {
    //   const response = await fetch(`${BASEAPIURL}/InsertHealthBooking`, {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify({
    //       tokenData: token,
    //       booking,
    //     }),
    //   });
    //   const result = await response.json();

    //   if (result.status === true) {
    //     addNotification("success", "Booking confirmed successfully!");

    //     return { bookingID: result.HealtBookingID, bookingData: result.Booking };
    //   } else {
    //     addNotification("error", result.message || "Booking failed.");
    //   }
    // } catch (error) {
    //   console.error(error);
    //   addNotification("error", "API Error");
    // }
  };

  // const handleSubmitBookingApi = async () => {
  //   const storedMemberID = sessionStorage.getItem("MemberID");
  //   const storedMemberName = sessionStorage.getItem("MemberName");

  //   if (!storedMemberID || !storedMemberName) {
  //     addNotification("error", "User not logged in.");
  //     return;
  //   }

  //   if (selectedSlots.length === 0) {
  //     addNotification("warning", "Please select at least one slot.");
  //     return;
  //   }

  //   const bookingDtl = selectedSlots.map((slot) => {
  //     const memberPrice = parseFloat(slot.MemberPrice) || 500;
  //     const guestPrice = parseFloat(slot.GuestPrice) || memberPrice + 100;
  //     const { subtotal, taxPercentage, tax, total, discountPercent, discountedValue, amountAfterDiscount } = calculateCartTotals();

  //     const BookingMemDtl = [
  //       ...selectedMembers.map((m) => ({
  //         MemberType: "self",
  //         Name: m.MemName,
  //         MobileNo: m.MemMobileNo || "N/A",
  //       })),
  //       ...guests
  //         .filter((g) => g.name)
  //         .map((g) => ({
  //           MemberType: "Guest",
  //           Name: g.name,
  //           MobileNo: g.mobile || "N/A",
  //         })),
  //     ];

  //     return {
  //       Fty_ID: selectedFacility?.Facility_ID,
  //       FtyCourt_ID: selectedCourt?.CourtID,
  //       SlotID: slot.SlotID,
  //       EventDate: new Date(slot.BookingDate).toISOString(),
  //       BookingRate: +amountAfterDiscount.toFixed(2),
  //       GSTAmount: +tax.toFixed(2),
  //       Is_TaxInclude: slot.TaxIsInclude || false,
  //       DiscountAmount: +discountedValue.toFixed(2),
  //       DiscountPercentage: discountPercent,
  //       BookingMemDtl,
  //     };
  //   });

  //   const totalBookingPrice = bookingDtl.reduce(
  //     (sum, item) => sum + item.BookingRate,
  //     0
  //   );

  //   const totalTaxAmount = bookingDtl.reduce(
  //     (sum, item) => sum + item.GSTAmount,
  //     0
  //   );
  //   const bookingDisAmount = bookingDtl.reduce(
  //     (sum, item) => sum + item.DiscountAmount,
  //     0
  //   );

  //   const grossTotal = totalBookingPrice + totalTaxAmount;
  //   const totalNetAmount = grossTotal - bookingDisAmount;

  //   const booking = {
  //     BookingDate: new Date().toISOString(),
  //     MemberID: parseInt(storedMemberID),
  //     BookingSaveDate: new Date().toISOString(),
  //     BookingPrice: +totalBookingPrice.toFixed(2),
  //     BookingTaxAmount: +totalTaxAmount.toFixed(2),
  //     BookingNetAmount: +totalNetAmount.toFixed(2),
  //     BookingPaymentStatus: "pending",
  //     BookingPadAmount: +totalNetAmount.toFixed(2),
  //     BookingDisAmount: +bookingDisAmount.toFixed(2),
  //     BookingDtl: bookingDtl,
  //   };

  //   try {
  //     const response = await fetch(`${BASEAPIURL}/InsertHealthBooking`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         tokenData: token,
  //         booking,
  //       }),
  //     });
  //     const result = await response.json();

  //     if (result.status === true) {
  //       addNotification("success", "Booking confirmed successfully!");

  //       return { bookingID: result.HealtBookingID, bookingData: result.Booking };
  //     } else {
  //       addNotification("error", result.message || "Booking failed.");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     addNotification("error", "API Error");
  //   }
  // };

  const handleAddToCart = async () => {
    const { bookingID, bookingData } = await handleSubmitBooking();

    if (!bookingID) {
      console.warn("No BookingID returned; cart not updated.");
      return;
    }

    const cartItem = {
      type: "Health",
      apiType: "health",
      bookId: bookingID,

      details: {
        facility: selectedFacility?.Facility_Name || "Unknown Facility",
        court: selectedCourt?.CourtName || "Unknown Court",
        slots: selectedSlots.map((s) => s.SlotName),
        date: selectedSlots[0]?.BookingDate,
        members: selectedMembers.length,
        guests: guests.filter((g) => g.name).length,
      },

      pricing: {
        base: bookingData?.BookingPrice,
        tax: bookingData?.BookingTaxAmount,
        disAmount: bookingData?.BookingDisAmount,
        total: bookingData?.BookingNetAmount,
      },

      payload: {
        BookingID: bookingID,
        MemberID: parseInt(sessionStorage.getItem("MemberID")),
        BookingDtl: selectedSlots.map((slot) => ({
          Fty_ID: selectedFacility?.Facility_ID,
          FtyCourt_ID: selectedCourt?.CourtID,
          SlotID: slot.SlotID,
          EventDate: new Date(slot.BookingDate).toISOString(),
        })),
      },
    };

    // 🔎 Get existing cart
    const existingCart = localStorage.getItem("cart");
    let existingItems = existingCart ? JSON.parse(existingCart) : [];

    // 🚫 Prevent duplicate booking
    const alreadyExists = existingItems.some(
      (item) => item.type === "Health" && item.bookId === bookingID,
    );

    if (alreadyExists) {
      console.warn("Booking already exists in cart.");
      return;
    }

    // ✅ Add to cart
    existingItems.push(cartItem);
    localStorage.setItem("cart", JSON.stringify(existingItems));

    navigate("/dashboard/cart");
  };

  useEffect(() => {
    localStorage.removeItem("cart");
  }, []);

  const renderNotifications = () => {
    return (
      <div className="notifications-container">
        {showNotifications.map((notification) => (
          <div
            key={notification.id}
            className={`notification notification-${notification.type}`}
          >
            <div className="notification-content">
              {notification.type === "error" && (
                <IoWarning className="notification-icon" />
              )}
              {notification.type === "success" && (
                <IoCheckmarkCircle className="notification-icon" />
              )}
              {notification.type === "warning" && (
                <IoWarning className="notification-icon" />
              )}
              <span>{notification.message}</span>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const memberID = sessionStorage.getItem("MemberID");
  const memberName = sessionStorage.getItem("MemberName");
  const handleBack = () => navigate(-1);
  const [memberData, setMemberData] = useState({});
  const [memberImage, setMemberImage] = useState(logo);
  useEffect(() => {
    if (!memberID) {
      setError("No MemberID found in sessionStorage.");
      setLoading(false);
      return;
    }
    const myHeaders = new Headers({ "Content-Type": "application/json" });
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ tokenData: token }),
      redirect: "follow",
    };
    fetch(`${BASEAPIURL}/MemberByID?MainID=${memberID}`, requestOptions)
      .then((res) => {
        if (!res.ok) throw new Error(`Error fetching member  ${res.status}`);
        return res.json();
      })
      .then((result) => {
        if (!result?.data) throw new Error("No member data found.");
        const data = result.data;
        setMemberData(data);
        if (data?.ImageBase64?.startsWith("image")) {
          setMemberImage(data.ImageBase64);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Failed to fetch member data.");
        setLoading(false);
      });
  }, []);

  return (
    <div className="booking-page">
      {showBackButton && (
        <>
          <div className="mb-4">
            <button
              className="btn btn-outline-secondary d-flex align-items-center"
              onClick={handleBack}
            >
              <IoArrowBackSharp className="me-2" />
              Back
            </button>
          </div>
          <div
            className="rounded-5"
            style={{
              minHeight: "50px",
              padding: "10px",
              marginTop: "50px",
              background:
                "linear-gradient(90deg, rgba(200, 182, 166, 1) 17%, rgba(217, 164, 117, 1) 66%, rgba(252, 176, 69, 1) 100%)",
            }}
          >
            <div className="row align-items-center">
              <div className="col-12 col-md-4 text-center">
                <img
                  src={memberImage}
                  className="rounded-circle border border-4"
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "cover",
                    marginTop: "-70px",
                    backgroundColor: "white",
                  }}
                  alt="member"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = logo;
                  }}
                />
              </div>
              <div className="col-12 col-md-4 text-center text-white mt-3">
                <h3>{memberData.MemName || "N/A"}</h3>
              </div>
              <div className="col-12 col-md-4 text-center text-white mt-3">
                <h5>Member since: {formatDate(memberData.MemRegDt)}</h5>
                <h5>Membership Type: {memberData.MemType}</h5>
                <h5 className="mt-2">Membership No: {memberData.MemMSNO}</h5>
              </div>
            </div>
          </div>
        </>
      )}
      {renderNotifications()}
      <div className="progress-section">
        <h1 className="page-title text-center"> Sports Booking</h1>
        <div className="progress-bar-desktop d-none d-md-block">
          <div className="progress-container">
            <div className="progress-steps">
              {steps.map((step, index) => (
                <div
                  key={index}
                  ref={(el) => (progressStepsRef.current[index] = el)}
                  className={`step ${
                    currentStep === index + 1
                      ? "active"
                      : currentStep > index + 1
                        ? "completed"
                        : ""
                  }`}
                >
                  <div className="step-content">
                    <div className="step-icon">{step.icon}</div>
                    <div className="step-label">{step.label}</div>
                    {currentStep > index + 1 && (
                      <div className="step-check">
                        <IoCheckmarkCircle />
                      </div>
                    )}
                  </div>
                  {index < steps.length - 1 && (
                    <div className="progress-line"></div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="selection-summary ">
            <div className="summary-content">
              {(currentStep >= 1.5 || currentStep >= 2) && (
                <div className="d-flex flex-wrap gap-3">
                  {currentStep >= 1.5 && (
                    <div className="summary-item flex-fill">
                      <IoPeople className="summary-icon" />
                      <div>
                        <strong>Facility:</strong>
                        <span>
                          {" "}
                          {selectedFacility?.Facility_Name ||
                            "Please Select Facility"}
                        </span>
                      </div>
                    </div>
                  )}
                  {currentStep >= 2 && (
                    <div className="summary-item flex-fill">
                      <IoCalendar className="summary-icon" />
                      <div>
                        <strong>Court:</strong>
                        <span>
                          {" "}
                          {selectedCourt?.CourtName || "Please Select Court"}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="d-flex flex-wrap gap-3">
                {currentStep >= 3 && (
                  <div className="d-flex flex-wrap gap- ">
                    {currentStep >= 3 && selectedSlots.length > 0 && (
                      <div className="summary-item">
                        <IoCalendar className="summary-icon" />
                        <div>
                          <strong>Date and Slot</strong>
                          <strong
                            style={{
                              fontSize: "16px",
                            }}
                          >
                            {selectedSlots
                              .map(
                                (slot) =>
                                  `${formatDateNum(slot.BookingDate)} ${slot.Duration}`,
                              )
                              .join(", ") || "Please Select Slots"}
                          </strong>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {currentStep < 1.5 && (
                <p className="text-muted">No selections made yet.</p>
              )}
            </div>
          </div>
        </div>
        <div className="progress-bar-mobile d-md-none">
          <div className="mobile-progress-container">
            <div className="mobile-progress-steps">
              {steps.map((step, index) => (
                <div
                  key={index}
                  className={`mobile-step ${
                    currentStep === index + 1 ? "active" : ""
                  }`}
                >
                  <div className="mobile-step-content">
                    <div className="mobile-step-icon">{step.icon}</div>
                    <div className="mobile-step-label">{step.label}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mobile-progress-indicator">
              <div
                className="mobile-progress-fill"
                style={{
                  width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
                }}
              ></div>
            </div>
          </div>
          <div className="selection-summary mt-4">
            <h5 className="summary-title">Your Selections</h5>
            <div className="summary-content d-flex">
              {currentStep >= 1.5 && (
                <div className="col-md-6 d-flex align-items-center">
                  <IoPeople className="summary-icon me-2" />
                  <div>
                    <strong>Facility:</strong>
                    <span>
                      {" "}
                      {selectedFacility?.Facility_Name || "Please Select"}
                    </span>
                  </div>
                </div>
              )}
              {currentStep >= 2 && (
                <div className="col-md-6 d-flex align-items-center">
                  <IoCalendar className="summary-icon me-2" />
                  <div>
                    <strong>Court:</strong>
                    <span> {selectedCourt?.CourtName || "Please Select"}</span>
                  </div>
                </div>
              )}
              {currentStep >= 3 && selectedSlots.length > 0 && (
                <div className="summary-item">
                  <IoCalendar className="summary-icon" />
                  <div>
                    <strong>Dates & Slots:</strong>
                    <span>
                      {" "}
                      {selectedSlots
                        .map((slot) => `${slot.BookingDate} ${slot.Duration}`)
                        .join(", ") || "Please Select"}
                    </span>
                  </div>
                </div>
              )}
              {/* {currentStep >= 4 &&
                (selectedMembers.length > 0 || guests.length > 0) && (
                  <div className="summary-item">
                    <IoPeople className="summary-icon" />
                    <div>
                      <strong>Players:</strong>
                      <span> {selectedMembers.length +
                        guests.filter((g) => g.name).length} ({selectedMembers.length} members,{" "}
                        {guests.filter((g) => g.name).length} guests)</span>
                    </div>
                  </div>
                )} */}

              {currentStep < 1.5 && (
                <p className="text-muted">No selections made yet.</p>
              )}
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className={currentStep !== 1 ? "d-none" : ""}>
            {loadingGroups ? (
              <div className="d-flex justify-content-center align-items-center py-5">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <span className="ms-2">Loading facility groups...</span>
              </div>
            ) : (
              <div className="row g-4">
                {
                  facilityGroups.length === 0 && (
                    <div className="col-12 text-center py-5">
                      <p className="text-muted">
                        No facility groups available.
                      </p>
                    </div>
                  )
                  // : (
                  //   facilityGroups
                  //     .filter((g) => g.FacilityGroupID === 1)
                  //     .map((g) => (
                  //       <div
                  //         key={g.FacilityGroupID}
                  //         className="col-12 col-sm-6 col-md-4 col-lg-3"
                  //       >
                  //         <div
                  //           className="card card-facility"
                  //           onClick={() => handleGroupClick(g)}
                  //           role="button"
                  //           tabIndex={0}
                  //           onKeyDown={(e) =>
                  //             e.key === "Enter" && handleGroupClick(g)
                  //           }
                  //         >
                  //           <div className="card-img-wrapper">
                  //             <img
                  //               src={
                  //                 g.FacilityImages?.[0] ||
                  //                 "https://via.placeholder.com/300x160?text=Facility+Group"
                  //               }
                  //               alt={g.FacilityName}
                  //               className="card-img"
                  //             />
                  //             <div className="card-overlay">
                  //               <div className="overlay-content">
                  //                 <IoPeople className="overlay-icon" />
                  //                 <span className="overlay-text">
                  //                   {g.FacilityName}
                  //                 </span>
                  //               </div>
                  //             </div>
                  //           </div>
                  //           <div className="card-body">
                  //             <h3 className="facility-name">{g.FacilityName}</h3>
                  //             <p className="meta">{g.FacilityDescShort}</p>
                  //           </div>
                  //         </div>
                  //       </div>
                  //     ))
                  // )
                }
              </div>
            )}
          </div>
          <div className={currentStep !== 1.5 ? "d-none" : ""}>
            {facilities.length === 0 ? (
              <div className="text-center py-5">
                <p className="text-muted">
                  No facilities available in this group.
                </p>
              </div>
            ) : (
              <div className="row g-4">
                {facilities.map((f) => (
                  <div
                    key={f.Facility_ID}
                    className="col-12 col-sm-6 col-md-4 col-lg-3"
                  >
                    <div
                      className="card card-facility"
                      onClick={() => handleFacilityClick(f)}
                    >
                      <div className="card-img-wrapper">
                        <img
                          src={
                            f.Facility_Image?.[0] ||
                            "https://via.placeholder.com/300x160?text=Facility"
                          }
                          alt={f.Facility_Name}
                          className="card-img"
                        />
                        <div className="card-overlay">
                          <div className="overlay-content">
                            <IoCalendar className="overlay-icon" />
                            <span className="overlay-text">
                              {f.Facility_Name}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <h3 className="facility-name">{f.Facility_Name}</h3>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className={currentStep !== 2 ? "d-none" : ""}>
            {loadingCourts ? (
              <div className="d-flex justify-content-center align-items-center py-5">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <span className="ms-2">Loading courts...</span>
              </div>
            ) : (
              <div className="row g-4">
                {courts.map((court) => (
                  <div
                    key={court.CourtID}
                    className="col-12 col-sm-6 col-md-4 col-lg-3"
                  >
                    <div
                      className="card card-court"
                      onClick={() => handleCourtClick(court)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) =>
                        e.key === "Enter" && handleCourtClick(court)
                      }
                    >
                      <div className="card-body">
                        <h3 className="court-name">
                          {court.CourtName || `Court ${court.CourtID}`}
                        </h3>
                        <div className="court-meta">
                          {court.Price && (
                            <span className="badge bg-success">
                              ₹{court.Price}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="d-flex justify-content-start mt-4">
              <button
                className="btn btn-outline btn-lg"
                onClick={() => setCurrentStep(1.5)}
              >
                ← Back
              </button>
            </div>
          </div>

          {/* MERGED STEP 3: Dates & Slots */}
          <div className={currentStep !== 3 ? "d-none" : ""}>
            <div className="card card-dates-slots">
              <div className="card-header">
                <h5 className="mb-0">Select Dates & Time Slots</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12  col-lg-3">
                    <div className="form-group ">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["StaticDatePicker"]}>
                          <StaticDatePicker
                            displayStaticWrapperAs="desktop"
                            value={selectedDate}
                            onChange={handleDateChange}
                            minDate={dayjs()} // today
                            maxDate={dayjs().add(45, "day")} // today + 45 days
                            sx={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              padding: "16px",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                              "& .MuiPickersDay-root": {
                                borderRadius: "50%",
                              },
                              "& .Mui-selected": {
                                backgroundColor: "#007bff !important",
                                color: "white !important",
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    <div className="selected-dates mt-3">
                      {bookingDates.map((date, index) => (
                        <div key={index} className="badge bg-primary me-2 mb-2">
                          {formatDateNum(date)}
                          <button
                            type="button"
                            className="btn-close btn-close-white ms-2"
                            onClick={() => removeDate(date)}
                            aria-label={`Remove ${date}`}
                          ></button>
                        </div>
                      ))}
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-md-start mt-4 gap-2">
                      <button
                        className="btn btn-outline btn-lg"
                        onClick={goBack}
                      >
                        ← Back
                      </button>
                      {selectedSlots.length > 0 && (
                        <button
                          className="btn btn-primary btn-lg"
                          onClick={() => setCurrentStep(4)}
                        >
                          Next: Add Participants
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-8">
                    {loadingSlots ? (
                      <div className="d-flex justify-content-center align-items-center ">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <span className="ms-2">Loading slots...</span>
                      </div>
                    ) : (
                      <div>
                        {slots.length === 0 ? (
                          <div className="alert alert-info text-center py-4">
                            <IoWarning className="me-2" />
                            Select a date to view available slots
                          </div>
                        ) : (
                          bookingDates.map((date) => (
                            <div key={date}>
                              <h5 className="mb-2">{formatDateNum(date)}</h5>
                              <div className="row g-2 ">
                                {healthAvailabilty.map((item) =>
                                  slots
                                    .filter(
                                      (slot) =>
                                        slot.BookingDate === date &&
                                        slot.SlotID === item.Slot_ID,
                                    )
                                    // &&
                                    // item.Status === "Available",
                                    .map((slot, index) => (
                                      <div
                                        key={index}
                                        className="col-12 col-lg-6"
                                      >
                                        <div
                                          className={`card col-12 slot-card ${
                                            slot.Status === "Booked"
                                              ? "disabled"
                                              : ""
                                          }`}
                                        >
                                          <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start">
                                              <div>
                                                <h5 className="mb-1">
                                                  {slot.Duration}
                                                </h5>
                                                <div className="small text-muted">
                                                  Member: ₹{slot.MemberPrice} |
                                                  Guest: ₹{slot.GuestPrice}
                                                </div>
                                              </div>
                                              <button
                                                className={`btn btn-sm ${
                                                  selectedSlots.find(
                                                    (s) =>
                                                      s.SlotID ===
                                                        slot.SlotID &&
                                                      s.BookingDate ===
                                                        slot.BookingDate,
                                                  ) || item.Status === "Booked"
                                                    ? "btn-danger"
                                                    : "btn-success"
                                                }`}
                                                onClick={() =>
                                                  handleSlotClick(slot)
                                                }
                                                disabled={
                                                  item.Status === "Booked"
                                                }
                                                aria-label={`${
                                                  selectedSlots.find(
                                                    (s) =>
                                                      s.SlotID ===
                                                        slot.SlotID &&
                                                      s.BookingDate ===
                                                        slot.BookingDate,
                                                  )
                                                    ? "Deselect"
                                                    : "Select"
                                                } slot ${slot.Duration}`}
                                              >
                                                {item.Status === "Booked"
                                                  ? "Booked"
                                                  : selectedSlots.find(
                                                        (s) =>
                                                          s.SlotID ===
                                                            slot.SlotID &&
                                                          s.BookingDate ===
                                                            slot.BookingDate,
                                                      )
                                                    ? "Deselect"
                                                    : "Select"}
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )),
                                )}
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={currentStep !== 4 ? "d-none" : ""}>
            <div className="card card-participants shadow-sm">
              <div className="card-header">
                <h5 className="mb-0">Add Participants</h5>
              </div>
              <div className="card-body">
                <div className="row g-4">
                  <div className="col-12 col-md-7">
                    <div className="mb-4">
                      <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        id="uncontrolled-tab-example"
                        className="mb-3"
                      >
                        <Tab eventKey="Members" title="Members">
                          <label className="form-label">Search Members</label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <IoSearch />
                            </span>
                            <input
                              type="text"
                              className="form-control dark-placeholder"
                              style={{ border: "1px solid black" }}
                              placeholder="Name, ID, or Mobile..."
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                              disabled={
                                selectedMembers.length + guests.length >=
                                playerLimit
                              }
                              onBlur={() =>
                                setTimeout(() => setSearchResults([]), 200)
                              }
                            />
                          </div>
                          {searchResults.length > 0 && (
                            <div
                              className="dropdown-menu show w-50"
                              style={{
                                maxHeight: "200px", // adjust as needed
                                overflowY: "auto",
                              }}
                            >
                              {searchResults.slice(0, 10).map((mem) => (
                                <div
                                  key={mem.MemID}
                                  className="dropdown-item"
                                  onClick={() => {
                                    if (
                                      !selectedMembers.find(
                                        (m) => m.MemID === mem.MemID,
                                      ) &&
                                      selectedMembers.length + guests.length <
                                        playerLimit
                                    ) {
                                      setSelectedMembers([
                                        ...selectedMembers,
                                        { ...mem, isDependent: false },
                                      ]);
                                    }
                                    setSearchQuery("");
                                    setSearchResults([]);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <strong>{mem.MemName}</strong> ({mem.MemMSNO}){" "}
                                  <br />
                                  <small className="text-muted">
                                    {mem.MemMobileNo}
                                  </small>
                                </div>
                              ))}
                            </div>
                          )}
                        </Tab>
                        <Tab eventKey="Dependents" title="Dependents">
                          <div className="mb-4">
                            <h5 className="mb-3">Dependents</h5>
                            {dependents.length === 0 ? (
                              <p className="text-muted">
                                No dependents available.
                              </p>
                            ) : (
                              <div className="list-group">
                                {dependents.map((dep) => {
                                  const isSelected = selectedMembers.find(
                                    (m) => m.MemID === dep.MemID,
                                  );

                                  return (
                                    <div
                                      key={dep.MemID}
                                      className={`list-group-item list-group-item-action py-3 `}
                                      onClick={() => {
                                        if (
                                          !isSelected &&
                                          selectedMembers.length +
                                            guests.length <
                                            playerLimit
                                        ) {
                                          setSelectedMembers([
                                            ...selectedMembers,
                                            { ...dep, isDependent: true },
                                          ]);
                                        }
                                      }}
                                      style={{
                                        cursor: isSelected
                                          ? "default"
                                          : "pointer",
                                      }}
                                    >
                                      <div
                                        className={`d-flex justify-content-between align-items-center`}
                                      >
                                        <div>
                                          <strong>{dep.Name}</strong>{" "}
                                          (Dependent)
                                        </div>
                                        <IoPeople className="text-success" />
                                      </div>
                                      <small className="text-muted">
                                        {dep.Relation || "N/A"}
                                      </small>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </Tab>
                        <Tab eventKey="Guest" title="Guest">
                          {guests.length === 0 && (
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm mb-3"
                              onClick={addGuest}
                              disabled={
                                selectedMembers.length + guests.length >=
                                playerLimit
                              }
                            >
                              ➕ Add Guest
                            </button>
                          )}
                          {guests.length > 0 && (
                            <div className="mb-4">
                              <label className="form-label">
                                Guest Details
                              </label>
                              {guests.map((g, i) => (
                                <div key={i} className="row g-2 mb-2">
                                  <div className="col-12 col-sm-6">
                                    <input
                                      type="text"
                                      placeholder="Name"
                                      className="form-control"
                                      value={g.name}
                                      onChange={(e) => {
                                        const value = e.target.value.replace(
                                          /[^A-Za-z\s]/g,
                                          "",
                                        );
                                        const updated = [...guests];
                                        updated[i].name = value;
                                        setGuests(updated);
                                      }}
                                    />
                                  </div>
                                  <div className="col-12 col-sm-5">
                                    <input
                                      type="tel"
                                      placeholder="Mobile number"
                                      className="form-control"
                                      value={g.mobile}
                                      required
                                      pattern="[0-9]{10}"
                                      maxLength={10}
                                      onChange={(e) => {
                                        const value = e.target.value.replace(
                                          /\D/g,
                                          "",
                                        );
                                        if (value.length <= 10) {
                                          const updated = [...guests];
                                          updated[i].mobile = value;
                                          setGuests(updated);
                                        }
                                      }}
                                    />
                                  </div>
                                  <div className="col-12 col-sm-1 d-flex align-items-center">
                                    {i === guests.length - 1 ? (
                                      <button
                                        className="btn btn-sm btn-success"
                                        onClick={addGuest}
                                        disabled={
                                          selectedMembers.length +
                                            guests.length >=
                                          playerLimit
                                        }
                                      >
                                        +
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => removeGuest(i)}
                                      >
                                        ×
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </Tab>
                      </Tabs>
                    </div>
                     <div className="d-flex flex-column flex-sm-row justify-content-start mt-4 gap-2">
                  <button
                    className="btn btn-outline-secondary btn-lg"
                    onClick={goBack}
                  >
                    ← Back
                  </button>
                  <button
                    className="btn btn-success btn-lg"
                    onClick={() => setCurrentStep(5)}
                    disabled={
                      selectedMembers.length + guests.length < playerLimit ||
                      bookingDates.length === 0 ||
                      (activeTab === "Guest" &&
                        (guests.length === 0 ||
                          !areAllMobilesValid ||
                          !areAllNamesValid))
                    }
                  >
                    ✅ Confirm Bookings
                  </button>
                </div>
                  </div>
                  <div className="col-12 col-md-5">
                    <div className="card card-selected-participants">
                      <div className="card-header">
                        <h5 className="mb-0">
                          {selectedMembers.length +
                            guests.filter((g) => g.name).length >
                          0
                            ? `Selected Participants `
                            : "No Participants Selected"}
                        </h5>
                      </div>
                      <div className="card-body">
                        {selectedMembers.map((mem) => {
                          return (
                            <div
                              key={mem.MemID}
                              className="d-flex justify-content-between align-items-center mb-3 participant-item"
                            >
                              <div>
                                <div className="d-flex align-items-center">
                                  <IoPerson className="me-2 text-primary" />
                                  <strong>
                                    {mem.MemName} {mem.Name}
                                  </strong>
                                </div>
                                <div className="small text-muted">
                                  {mem.MemMSNO}
                                  {mem.isDependent && (
                                    <span className="badge bg-secondary ms-2">
                                      Dependent
                                    </span>
                                  )}
                                  {mem.MemMSNO === "Self" && (
                                    <span className="badge bg-info ms-2">
                                      You
                                    </span>
                                  )}
                                </div>
                              </div>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() =>
                                  setSelectedMembers(
                                    selectedMembers.filter(
                                      (m) => m.MemID !== mem.MemID,
                                    ),
                                  )
                                }
                                aria-label={`Remove ${mem.MemName}`}
                              >
                                Remove
                              </button>
                            </div>
                          );
                        })}
                        {guests.map(
                          (guest, index) =>
                            guest.name.trim() && (
                              <div
                                key={`guest-${index}`}
                                className="d-flex justify-content-between align-items-center mb-3 participant-item"
                              >
                                <div>
                                  <div className="d-flex align-items-center">
                                    <IoPerson className="me-2 text-primary" />
                                    <strong>{guest.name}</strong>
                                  </div>
                                  <div className="small text-muted">
                                    {guest.mobile}
                                  </div>
                                </div>
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => removeGuest(index)}
                                  aria-label={`Remove ${guest.name}`}
                                >
                                  Remove
                                </button>
                              </div>
                            ),
                        )}
                        {selectedMembers.length + guests.length > 0 && (
                          <div className="mt-3 p-3 bg-light rounded">
                            <div className="d-flex justify-content-between">
                              <span>Players:</span>
                              <span>
                                {selectedMembers.length +
                                  guests.filter((g) => g.name).length}
                                /{playerLimit}
                              </span>
                            </div>
                            <div className="progress mt-2">
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                  width: `${Math.min(
                                    100,
                                    (selectedMembers.length / playerLimit) *
                                      100,
                                  )}%`,
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
          </div>
          <div className={currentStep !== 5 ? "d-none" : ""}>
            <div className="row g-4">
              <div className="col-12 col-lg-8">
                <div className="card card-review">
                  <div className="card-header">
                    <h5 className="mb-0">Booking Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-6">
                        <strong>Facility:</strong>
                      </div>
                      <div className="col-6">
                        {selectedFacility?.Facility_Name || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-6">
                        <strong>Court:</strong>
                      </div>
                      <div className="col-6">
                        {selectedCourt?.CourtName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-6">
                        <strong>Date:</strong>
                      </div>
                      <div className="col-6">
                        {formatDateNum(bookingDates.join(", ")) || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-6">
                        <strong>Players:</strong>
                      </div>
                      <div className="col-6">
                        {selectedMembers.length +
                          guests.filter((g) => g.name).length}{" "}
                        ({selectedMembers.length} members,{" "}
                        {guests.filter((g) => g.name).length} guests)
                      </div>
                    </div>
                    <h5 className="mt-4 mb-3">Selected Slots</h5>
                    {cartItems.map((item, index) => (
                      <div key={index} className="border-bottom pb-3 mb-3">
                        <div className="row">
                          <div className="col-6">
                            <strong>{formatDateNum(item.slot.BookingDate)}</strong>
                          </div>
                          <div className="col-6 text-end">
                            <strong>{item.slot.Duration}</strong>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="card card-summary sticky-top">
                  <div className="card-header">
                    <h5 className="mb-0">Order Summary</h5>
                  </div>
                  <div className="card-body">
                    {(() => {
                      const {
                        subtotal,
                        taxPercentage,
                        tax,
                        total,
                        discountPercent,
                        discountedValue,
                        amountAfterDiscount,
                      } = calculateCartTotals();
                      return (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span>Subtotal:</span>
                            <span>₹{subtotal?.toFixed(2)}</span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span>Discount ({discountPercent}%) :</span>
                            <span>₹{discountedValue?.toFixed(2)} </span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span>Taxble Value :</span>
                            <span>₹{amountAfterDiscount?.toFixed(2)} </span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span>GST ({taxPercentage}%) :</span>
                            <span>₹{tax?.toFixed(2)}</span>
                          </div>
                          <div className="d-flex justify-content-between fw-bold mt-3 pt-2 border-top">
                            <span>Net Amount :</span>
                            <span>₹{total?.toFixed(2)}</span>
                          </div>
                          <div className="mt-4">
                            <h5 className="mb-3">Participants</h5>
                            <ul className="list-unstyled">
                              {selectedMembers.map((member) => (
                                <li key={member.MemID} className="mb-2">
                                  <div className="d-flex align-items-center">
                                    <IoPerson className="me-2 text-primary" />
                                    <strong>
                                      {member.MemName || member.Name}
                                    </strong>
                                    <span className="ms-1 badge bg-secondary">
                                      {member.MemMSNO === "Self"
                                        ? "You"
                                        : member.isDependent
                                          ? "Dependent"
                                          : "Member"}
                                    </span>
                                  </div>
                                </li>
                              ))}
                              {guests
                                .filter((g) => g.name)
                                .map((guest, index) => (
                                  <li key={index} className="mb-2">
                                    <div className="d-flex align-items-center">
                                      <IoPerson className="me-2 text-warning" />
                                      <strong>{guest.name}</strong>
                                      <span className="ms-1 badge bg-secondary">
                                        Guest
                                      </span>
                                    </div>
                                  </li>
                                ))}
                            </ul>
                          </div>
                          <button
                            className="btn btn-success w-100 mt-4 btn-lg"
                            // onClick={handleAddToCart}
                            onClick={handleSubmitBooking}
                            // disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                ></span>
                                Processing...
                              </>
                            ) : (
                              <>
                                <IoCheckmarkCircle className="me-2" />
                                Add to Card & Proceed
                              </>
                            )}
                          </button>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex flex-column flex-md-row justify-content-md-start mt-4 gap-2">
              <button
                className="btn btn-outline btn-lg"
                onClick={() => setCurrentStep(4)}
              >
                ← Back to Participants
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
